import MyAddresses from './MyAddresses'

export default MyAddresses
